module.exports = __webpack_public_path__ + "static/img/bkg_icon.2d245ac5.png";